import { useDroppable } from '@dnd-kit/core';
import { Box, Tooltip } from '@mui/material';
import { PRIMARY, RED } from 'constants/colors';
import dayjs from 'dayjs';
import {
  AbsenceResponse,
  PlanningEntityIdentifier,
  PlanningEntityType
} from 'generated/index';
import { ElementType, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { brightness } from 'utils/misc';
import AbsenceTooltipBody from '../../components/AbsenceTooltipBody';

const Absence = ({
  id,
  absence,
  component,
  showTime,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier,
  scheduleStart
}: {
  id: string;
  absence: AbsenceResponse;
  component?: ElementType<any>;
  showTime?: boolean;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
  scheduleStart: string;
}) => {
  const { t } = useTranslation('', { keyPrefix: 'activityPlanning' });
  const [hovered, setHovered] = useState(false);

  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled: !showTime,
    data: {
      planningEntityType,
      planningEntityId,
      planningEntityIdentifier,
      scheduleStart,
      isDroppableCell: true
    }
  });

  return (
    <Tooltip
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      open={hovered}
      title={<AbsenceTooltipBody type={absence?.type} />}
    >
      <Box
        ref={setNodeRef}
        component={component || 'div'}
        display="flex"
        alignItems="center"
        sx={{
          boxSizing: 'border-box',
          color: isOver ? PRIMARY : '#023850',
          backgroundColor: isOver
            ? brightness(PRIMARY, 90)
            : brightness(RED, 90),
          border: `2px solid ${isOver ? PRIMARY : 'transparent'}`,
          boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
          borderRadius: '6px',
          width: '100%',
          height: '40px',
          padding: '0 10px',
          '+ *': {
            marginTop: '8px'
          }
        }}
      >
        {!showTime
          ? t('fullDayAbsent')
          : t('absentFromTil', {
              from: dayjs(absence.start).format('HH:mm'),
              to: dayjs(absence.end).format('HH:mm')
            })}
      </Box>
    </Tooltip>
  );
};

export default Absence;
